import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ListItem, Button, Stack, Grid, SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";

interface ISidebarMenu {
  // eslint-disable-next-line @typescript-eslint/ban-types
  icon?: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  href: string;
  label: string;
}
interface IContainerWithSidebar {
  menu: ISidebarMenu[];
  children: React.ReactNode;
}

const ContainerWithSidebar = ({ menu, children }: IContainerWithSidebar) => {
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <Stack direction="row" flexWrap="nowrap">
      <Grid container>
        <Grid
          item
          sx={{
            paddingTop: "60px",
          }}
        >
          {menu.map((item) => (
            <ListItem key={item.href} sx={{ m: "0", p: "10" }}>
              <Button
                onClick={() => {
                  navigate(item.href);
                }}
                startIcon={item.icon ? <item.icon /> : null}
                size="large"
                variant={item.href === location.pathname ? "contained" : "text"}
                sx={{
                  whiteSpace: "nowrap",
                }}
              >
                {item.label}
              </Button>
            </ListItem>
          ))}
        </Grid>

        <Grid
          item
          sx={{
            flexGrow: 1,
          }}
        >
          {children}
        </Grid>
      </Grid>
    </Stack>
  );
};

export default ContainerWithSidebar;
